<template>
  <ul
    class="board-list"
    :class="{
      'board-list--grid': layout === 'grid',
      'board-list--list': layout === 'list',
    }"
  >
    <BoardListing
      v-for="board in boards"
      :key="board.id"
      :board="board"
      :layout="layout"
      :sidebar-filter="sidebarFilter"
    />

    <!-- Intentional flex spacers -->
    <li class="nebula-card board-list__flex-spacer" />
    <li class="nebula-card board-list__flex-spacer" />
    <li class="nebula-card board-list__flex-spacer" />
  </ul>
</template>

<script>
import BoardListing from '@/components/home/BoardListing.vue';

export default {
  name: 'BoardList',
  components: {
    BoardListing,
  },
  props: {
    boards: {
      type: Array,
      default() {
        return [];
      },
    },
    layout: {
      type: String,
      default: 'grid', // this default is also set in the home mixin
    },
    sidebarFilter: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
.board-list {
  display: flex;
  list-style: none;
  padding: 0;

  &--grid {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: $nebula-space-3x;
  }

  &--list {
    flex-direction: column;
  }

  &__flex-spacer {
    margin-bottom: 0;
    opacity: 0;
    visibility: hidden;
  }
}
</style>
